<template>
  <div>
    <a-card
      :style="{ marginBottom: '1em' }"
      :header="$t('common.search')"
      :editable="false"
    >
      <template
        #header-buttons
      >
        <div class="is-pulled-right is-flex buttons">
          <b-button
            icon-left="filter-remove"
            @click="() => $store.dispatch('failures/resetFilters')"
          >
            {{ $t('common.navigation.reset_filters') }}
          </b-button>
          <a-select
            :manual-doc="userDoc"
            field="routes.failures.orderBy"
            :label="$t('common.order')"
            :options="keys($store.getters['failures/orderOptions'])"
            :labels="$store.getters['failures/orderOptions']"
          />
        </div>
      </template>

      <filters />
      <a-input
        :style="{ marginTop: '1em' }"
        :manual-doc="userDoc"
        field="routes.failures.search"
        :label="$t('common.quick_search')"
      />
    </a-card>
    <a-table
      :columns="user.routes.failures.columns"
      :data="$store.getters['failures/displayedItems']"
    >
      <template
        #actions="slotProps"
      >
        <b-icon
          v-if="slotProps.props.row.notified"
          :icon="slotProps.props.row.notified === 'receipt' ? 'email' : 'email-check'"
        />
      </template>
    </a-table>
    <more-docs-button
      module="failures"
    />
    <add-doc-button
      :doc-props="{}"
    />
  </div>
</template>

<script>
import ATable from '@/components/ATable'
import MoreDocsButton from '@/components/MoreDocsButton'
import { mapGetters, mapActions } from 'vuex'
import { keys } from 'lodash'
import Filters from './Failures/Filters'

export default {
  components: {
    Filters,
    MoreDocsButton
  },
  data() {
    return {
      userDoc: { module: 'user' }
    }
  },
  created () {
    this.$store.dispatch('failures/fetchDocs')
  },
  methods: {
    keys
  }
}
</script>
